"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

var _ExpandableConstants = require("./ExpandableConstants");

var INDENT_OPTIONS = {
  default: _ExpandableConstants.EXPANDABLE_PADDING_LEFT,
  compact: _ExpandableConstants.EXPANDABLE_PADDING_X,
  none: 0
};

var UIExpandableContents = _styledComponents.default.div.withConfig({
  displayName: "UIExpandableContents",
  componentId: "sc-19pchq2-0"
})(["padding-bottom:", ";padding-left:", ";padding-right:", ";padding-top:", ";>:last-child{margin-bottom:0;}"], _ExpandableConstants.EXPANDABLE_PADDING_BOTTOM, function (_ref) {
  var indentation = _ref.indentation;
  return typeof indentation === 'number' ? (0, _Styles.toPx)(indentation) : INDENT_OPTIONS[indentation];
}, function (_ref2) {
  var indentation = _ref2.indentation;
  return indentation === 'none' ? 0 : _ExpandableConstants.EXPANDABLE_PADDING_X;
}, function (_ref3) {
  var indentation = _ref3.indentation,
      use = _ref3.use;
  if (indentation === 'none') return 0;
  return use === 'enclosed' ? _ExpandableConstants.EXPANDABLE_DARK_PADDING_TOP : _ExpandableConstants.EXPANDABLE_PADDING_TOP;
});

UIExpandableContents.propTypes = {
  children: _propTypes.default.node,
  indentation: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(Object.keys(INDENT_OPTIONS))])
};
UIExpandableContents.defaultProps = {
  indentation: 'default'
};
UIExpandableContents.displayName = 'UIExpandableContents';
var _default = UIExpandableContents;
exports.default = _default;
module.exports = exports.default;